import type { FormTourConfig } from './formTour';

const CHANGE_CANDIDATE_STATUS_START_PATH = '/candidates';

export const changeCandidateStatusTour = {
  taskId: 'change_candidate_status',
  storageKey: 'onboarding-change-candidate-status-tour-step',
  startPath: CHANGE_CANDIDATE_STATUS_START_PATH,
  activePathPrefix: CHANGE_CANDIDATE_STATUS_START_PATH,
  navStepCount: 1,
  overlineLabel: ' Change status for Candidate Tour',
  steps: [
    {
      title: 'Open Candidates',
      description: 'Click Candidates in the sidebar to open the candidates list.',
      targetTestIds: ['@sidebar-candidates'],
    },
    {
      title: 'Open job statuses',
      description:
        'In the Job And Status column, click the job count chip to see jobs linked to this candidate.',
      targetTestIds: ['@candidates-job-statuses-chip'],
    },
    {
      title: 'Open change status',
      description: 'Click the status badge (or Change status) for a job to open the status form.',
      targetTestIds: ['@candidate-status-trigger'],
      highlightTargetTestIds: ['@candidate-job-status-row'],
      contextTargetTestIds: ['@candidates-jobs-modal'],
      closeTargetTestIdsOnBack: ['@candidate-status-modal', '@candidates-jobs-modal'],
    },
    {
      title: 'Select New Status',
      description:
        'Choose a status from the list below the note field. The tour will continue when a status is selected.',
      targetTestIds: ['@candidate-status-options', '@candidate-status-selected'],
      panelPlacement: 'above',
      closeTargetTestIdsOnBack: ['@candidate-status-modal'],
    },
    {
      title: 'Add an optional note',
      description: 'Optionally add a note about this status change in the note field at the top of the form.',
      targetTestIds: ['@candidate-status-note'],
      panelPlacement: 'above',
    },
    {
      title: 'Save the status change',
      description: 'Click Change Status to save. The tour will complete when your change is saved.',
      targetTestIds: ['@candidate-status-save'],
      panelPlacement: 'above',
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@candidates-table'],
    },
    1: {
      type: 'wait-for-target',
      advanceTo: 2,
      waitForTargetTestIds: ['@candidates-jobs-modal'],
    },
    2: {
      type: 'wait-for-target',
      advanceTo: 3,
      waitForTargetTestIds: ['@candidate-status-modal'],
    },
    3: {
      type: 'wait-for-target',
      advanceTo: 4,
      waitForTargetTestIds: ['@candidate-status-selected'],
    },
    4: { type: 'next' },
    5: {
      type: 'complete-when-target-absent',
      waitForAbsentTestIds: ['@candidate-status-modal'],
    },
  },
} as const satisfies FormTourConfig;
